// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__MRbvT","formItem":"styles_formItem__hJ4gq","formFull":"styles_formFull__rHDVv","InputNumber":"styles_InputNumber__9aO4w"};